import React, { useState } from "react";
import { Entry } from "../../../api/services";
import { Box, Typography, Link, withStyles } from "@material-ui/core";
import { AttachmentIcon, CommentIcon } from "../../../icons";
import { formatDatetime } from "../../../utils/formatDate";
import { useTruncate } from "../../../hooks";

interface CommentProps {
  entry: Entry;
}

const CommentText = withStyles(() => ({
  root: { wordBreak: "break-word" },
}))(Typography);

export const Comment: React.FC<CommentProps> = ({ entry }) => {
  // TEMPORARY - Until we start providing file details with each entry
  // Content of an attachment is usually "<<filename.txt>>"
  const isAttachment = entry.content.startsWith("<<");
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  const content = isAttachment
    ? entry.content.replace("<<", "").replace(">>", "")
    : entry.content;
  const hasLongContent = content.length > 500;
  const truncated = useTruncate(content, 500);

  return (
    <Box minHeight={70} display="flex">
      <Box flexShrink={1} mt={2} mr={1}>
        {isAttachment ? (
          <AttachmentIcon style={{ fill: "currentColor" }} />
        ) : (
          <CommentIcon style={{ fill: "currentColor" }} />
        )}
      </Box>
      <Box mt={1.25} mb={2}>
        <CommentText
          variant="body1"
          color="textPrimary"
          data-testid="Comment__Typography--content"
        >
          {isExpanded ? content : truncated}
          {hasLongContent && (
            <Box component="span" color="primary" mb={0.5}>
              <Link
                href="#"
                onClick={() => setIsExpanded(!isExpanded)}
                data-testid="Comment__Link--expand"
              >
                <br />
                {isExpanded ? "View less" : "View more"}
              </Link>
            </Box>
          )}
        </CommentText>
        <Typography
          variant="body2"
          color="textSecondary"
          data-testid="Comment__Typography--subtitle"
        >
          {`${entry.user}, ${formatDatetime(entry.createdDttm)}`}
        </Typography>
      </Box>
    </Box>
  );
};
